import { Link, NavLink, Outlet, ScrollRestoration, useLocation } from 'react-router';
import { APP_NAME, DISCOVER_WEEKLY_URL } from '../config';
import { usePendingAddCompletion } from '../lib/savedArtists';
import { AccountMenu } from './AccountMenu';
import { HeaderSearch } from './HeaderSearch';
import { ExternalIcon, HomeIcon, LibraryIcon, SearchIcon, SlidersIcon } from './Icons';
import { SignInDialog } from './SignInDialog';
import { SiteFooter } from './SiteFooter';
import './layout.css';

function Logo() {
  return (
    <Link to="/" className="disp logo" aria-label={`${APP_NAME} home`}>
      <span className="logo-dot" aria-hidden="true" />
      {APP_NAME}
    </Link>
  );
}

const navClass = ({ isActive }: { isActive: boolean }) => 'btn btn-ghost btn-sm' + (isActive ? ' is-active' : '');

export function Layout() {
  usePendingAddCompletion();
  const { pathname } = useLocation();

  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <header className="site-header">
        <div className="site-header-inner">
          <Logo />
          <div className="desktop-only header-search">
            <HeaderSearch />
          </div>
          <nav aria-label="Primary" className="primary-nav">
            <a href={DISCOVER_WEEKLY_URL} target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-sm desktop-only">
              Discover Weekly <ExternalIcon />
              <span className="visually-hidden">(opens Spotify)</span>
            </a>
            <NavLink to="/my-artists" className={(s) => navClass(s) + ' desktop-only'}>
              My Artists
            </NavLink>
            <NavLink to="/taste" className={(s) => navClass(s) + ' desktop-only'}>
              Taste
            </NavLink>
            {pathname !== '/search' && (
              <Link to="/search" className="icon-btn mobile-only" aria-label="Search artists">
                <SearchIcon />
              </Link>
            )}
            <AccountMenu />
          </nav>
        </div>
      </header>

      <main id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />

      <nav aria-label="Tabs" className="tabbar mobile-only">
        <NavLink to="/" end className="tab">
          <HomeIcon />
          Home
        </NavLink>
        <NavLink to="/search" className="tab">
          <SearchIcon size={24} />
          Search
        </NavLink>
        <NavLink to="/my-artists" className="tab">
          <LibraryIcon />
          My Artists
        </NavLink>
        <NavLink to="/taste" className="tab">
          <SlidersIcon />
          Taste
        </NavLink>
      </nav>

      <SignInDialog />
      <ScrollRestoration />
    </>
  );
}
